import type { InstagramCreator } from '@frontend/gql/social/graphql';
import type { ISocialAccount } from '@components';
import { getProspectFromSocialAccount } from '../../../../../../../components/widgets/Invite/utils';

// Helper function to transform Instagram creators to prospects
export const transformCreatorsToProspects = (creators: InstagramCreator[]) => {
  return creators.map((creator: InstagramCreator) => {
    const socialAccount: ISocialAccount = {
      username: creator.username,
      network_identifier: 'instagram',
      full_display_name: creator.username,
      email: creator.email || '',
      link: `https://www.instagram.com/${creator.username}/`,
      profile_picture: creator.profilePictureUrl || '',
      follower_count: creator.insights?.total?.followers || 0,
      country_code: creator.country || '',
      gender: creator.gender || '',
      is_in_instagram_marketplace: creator.inCreatorMarketplace || false,
    };
    // TODO: map country, followers, etc..
    return getProspectFromSocialAccount(socialAccount);
  });
};
